import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Results } from './components/Results';
import { PromoBanner } from './components/PromoBanner';
import { Courses } from './components/Courses';
import { Services } from './components/Services';
import { Testimonials } from './components/Testimonials';
import { CTA } from './components/CTA';
import { Contact } from './components/Contact';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <About data-id="element-3" />
      <Results data-id="element-4" />
      <PromoBanner data-id="element-5" />
      <Courses data-id="element-6" />
      <Services data-id="element-7" />
      <Testimonials data-id="element-8" />
      <CTA data-id="element-9" />
      <Contact data-id="element-10" />
      <FAQ data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}